import React, { Component } from 'react'
import Link from '../utils/link'
import CommunityForm from './community-form'

class Community extends Component {

  render() {

    let { title, content } = this.props

    return (
      <section className='contact contact--community' id="contact-form">

        <div className='contact__inner'>

          <div className='contact__content'>

            <div className='contact__menu'>

                <ul>
                  <li>Community</li>
                </ul>

            </div>

            <div className='contact__form'>

              <h2> { title }</h2>

              <div dangerouslySetInnerHTML={{ __html: content }} />
              
              <CommunityForm />

            </div>

          </div>

        </div>
        
      </section>
    )
  }
}

export default Community
